import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ProductSortMobileComponent } from './product-sort-mobile.component';

const DECLARATIONS = [ProductSortMobileComponent];
const MODULES = [CommonModule, MatIconModule, MatButtonModule];


@NgModule({
  declarations: [...DECLARATIONS],
  imports: [
    ...MODULES
  ],
  exports: [...DECLARATIONS, ...MODULES]
})
export class ProductSortMobileModule { }
